(function () {
  'use strict';

  angular
    .module('pairingAssignmentComplementConfirmationModal')
    .controller('pairingAssignmentComplementConfirmationModalCtrl', pairingAssignmentComplementConfirmationModalCtrl);

  function pairingAssignmentComplementConfirmationModalCtrl($uibModalInstance, modalParams, CommonMasterData, pairingAssignmentComplementConfirmationModalService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'pairingAssignmentComplementConfirmationModalCtrl';

    vm.model = {
      pairingAssignmentComplementConfirmationModalList: [],
      crewReqChanged: false,
      crewRequirements: modalParams.requiredList,
      patternId: modalParams.patternId,
      crewAssignedMap: adaptCrewAssignedData(modalParams.requiredList),
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    function adaptCrewAssignedData(crewRequirements) {
      var assignedData = {};
      crewRequirements.forEach(function (crewRequirement) {
        console.log(crewRequirement);
        assignedData[crewRequirement.crewTypeCode] = {
          "requiredCrew": crewRequirement.requiredCrew
        };
      });

      console.log(assignedData);
      return assignedData;
    }

    function validateCrewRequirement() {
      console.log(vm.model.crewAssignedMap);
      // vm.model.isCrewReqValid = false;
      // for (var key in vm.model.pairingConfig.crewReq) {
      //   if (vm.model.pairingConfig.crewReq.hasOwnProperty(key)) {
      //     if (vm.model.pairingConfig.crewReq[key] !== "" && parseInt(vm.model.pairingConfig.crewReq[key],0) !== 0) {
      //       vm.model.isCrewReqValid = true;
      //       vm.model.trainingOnlyPattern = false;
      //       break;
      //     }
      //   }
      // }
    }

    vm.setCrewRequirement = function(){
      validateCrewRequirement();
      vm.model.crewReqChanged = true;
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close("close");
    };

    vm.updateCrewRequirement = function () {
      var params = {};
      params.patternId = vm.model.patternId;
      params.crewRequiredDTOList = [];

      for (var k in vm.model.crewAssignedMap) {
        params.crewRequiredDTOList.push({
          "crewTypeCode": k,
          "requiredCrew": vm.model.crewAssignedMap[k].requiredCrew
        })
      }

      console.log(params);

      //pairingAssignmentComplementConfirmationModalService
      pairingAssignmentComplementConfirmationModalService.saveCrewRequirementsByPairingId(params,
        function (response) {
          console.log(response);
          // MessageService.success("New Crew Requirements updated for the Pairing");
        },
        function (error) {
          console.log(error);
          MessageService.error(error[0]);
        }
      );

      $uibModalInstance.close("save");
    };

  }
}());
